/**
 * newspaperSignTableModule
 * description：融合审签-newspaper表格组件
 * author：Qian.qianchen
 */
'use strict';
angular.module('newspaperSignTableModule', []).directive('newspaperSignTable', ['editIsLock', '$state', 'editNewspaperService', '$window', '$q', 'storageListenerService', 'trsHttpService', 'modalDialog', 'editingCenterService', 'newMediaService', 'publicToolService', function (editIsLock, $state, editNewspaperService, $window, $q, storageListenerService, trsHttpService, modalDialog, editingCenterService, newMediaService, publicToolService) {
    return {
        restrict: 'E',
        replace: false,
        templateUrl: './editingCenter/iWo/fusionSign/directive/newspaperSignTable/newspaperSignTable_tpl.html',
        scope: {
            productInfo: '=',
            selectedArray: '=',
            fromDate: '=',
            untilDate: '=',
            page: '=',
            banmianValue: '=',
            channelValue: '=',
            pubDate: '='
        },
        link: function ($scope, iElement, attrs) {
            initStatus();
            initData();

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    OprTime: '',
                    DocType: '',
                    isNewsPanelOpenArray: { 0: true },
                    sbgpreview: 2,
                    sbgedit: 2,
                    newspaperEdit: editNewspaperService.initNewspaperEdit(),
                };
                $scope.data = {
                    tableData: [],
                    firstFlag: true,
                };
                $scope.$on('refresh', initData);
                listenStorage();
            }

            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                if ($scope.data.firstFlag && $scope.$parent.data.channelValue) {
                    publicToolService.getModeconfiguration('newspaperDefaultOrderByTime').then((config) => {
                        $scope.$parent.data.selectedOrder = (config === 'true' ? editingCenterService.getNewspaperOrder()[1] : editingCenterService.getNewspaperOrder()[0]);
                        requestData();
                        $scope.data.firstFlag = false;
                    },
                    () => {
                        requestData();
                        $scope.data.firstFlag = false;
                    });
                } else {
                    if (!$scope.data.firstFlag && $scope.$parent.data.channelValue) {
                        requestData();
                    }
                }
            }

            /**
             * [listenStorage description]监听本地缓存
             * @return {[promise]} [description] promise
             */
            function listenStorage() {
                storageListenerService.listenNewspaper(function () {
                    initData();
                    storageListenerService.removeListener('newspaper');
                }, $scope);
            }

            /**
             * [requestData description] 表格数据请求
             * @return {[type]} [description]
             */
            function requestData() {
                var deffer = $q.defer();
                $scope.status.requestSuccess = false;
                var params = {
                    ServiceId: 'mlf_paper',
                    Methodname: 'queryShangBanDocs',
                    PaperId: $scope.$parent.data.channelValue, 
                    ChannelId: $scope.$parent.data.banmianValue ? $scope.$parent.data.banmianValue : '',
                    // SiteId: $scope.productInfo.SITEID,
                    PageIndex: $scope.page.CURRPAGE,
                    PageSize: $scope.page.PAGESIZE,
                    PubDate: $scope.pubDate,
                    OrderType: $scope.$parent.data.selectedOrder.value,
                    isPass: $scope.$parent.status.isPass,
                    NoPage: true
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    $scope.data.tableData = Array.isArray(data) ? data : data.DATA;
                    $scope.data.items = $scope.data.tableData;
                    $scope.status.requestSuccess = true;
                    $scope.page.PAGESIZE = data.PAGER.PAGESIZE;
                    $scope.page.CURRPAGE = data.PAGER.CURRPAGE;
                    $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                    $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
                    $scope.selectedArray = [];
                    if ($scope.data.items.length) {
                        editingCenterService.queryVerifyDoc($scope.data.items).then(function(data) {
                            $scope.data.filterReviseItem = $scope.data.items.filter((item) => item.DOCMODIFYSTATUSNAME !== '待修订' && item.verifyDocIsCanOper);
                        });
                    }
                    newMediaService.getReviseInfo($scope.data.items);
                    deffer.resolve(data);
                });
                return deffer.promise;
            }

            /**
             * [hasEditRight description] 判断用户是否有稿件编辑权限
             * @param  {[type]}  item [description] 稿件
             * @return {Boolean}      [description]
             */
            function hasEditRight(item) {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_fusion',
                    methodname: 'checkUserHasChannelDaiShenEditRight',
                    mediaType: 3,
                    objectId: item.METADATAID,
                    currChannleId: item.CHANNELID
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    defer.resolve(data);
                });
                return defer.promise;
            }

            /**
             * [selectItem description] 稿件选择/取消选择
             * @param  {[type]} item [description] 稿件
             * @return {[type]}      [description]
             */
            $scope.selectItem = function (item) {
                if ($scope.isChecked(item)) {
                    $scope.selectedArray = $scope.selectedArray.filter(function (_item, index) {
                        return item.METADATAID != _item.METADATAID;
                    });
                } else {
                    $scope.selectedArray.push(item);
                }
            };

            /**
             * [isChecked description] 判断稿件是否选中
             * @param  {[type]}  item [description] 稿件
             * @return {Boolean}      [description]
             */
            $scope.isChecked = function (item) {
                return $scope.selectedArray.some(function (_item, index) {
                    return item.METADATAID == _item.METADATAID;
                });
            };

            /**
             * [selectAll description] 全选/取消全选
             * @return {[type]} [description]
             */
            $scope.selectAll = function () {
                if ($scope.selectedArray.length === $scope.data.filterReviseItem.length) {
                    $scope.selectedArray = [];
                } else {
                    $scope.selectedArray = angular.copy($scope.data.filterReviseItem);
                }
            };

            /**
             * [isSelectAllBanmian description] 判断纸媒版面是否全选
             * @param  {[type]}  documents [description] 纸媒版面中的所有稿件
             * @return {Boolean}           [description]
             */
            $scope.isSelectAllBanmian = function (documents) {
                return documents.map(function (item, index) {
                    return item.METADATAID;
                }).every(function (item, index) {
                    return $scope.selectedArray.some(function (_item, _index) {
                        return item == _item.METADATAID;
                    });
                });
            };

            /**
             * [toggleOpen description] 版面展开收起
             * @param  {[object]} items [description] 版面对象
             * @param  {[int]} index [description] 版面下标
             * @return {[type]}       [description]
             */
            $scope.toggleOpen = function (items, index) {
                if (angular.isUndefined($scope.status.isNewsPanelOpenArray[index]) || $scope.status.isNewsPanelOpenArray[index] == false) {
                    $scope.status.isNewsPanelOpenArray[index] = true;

                } else {
                    $scope.status.isNewsPanelOpenArray[index] = false;
                }
            };

            /**
             * [isLockEditForNewspaper description:编辑前请求解锁]
             * @param  {[type]} item [description:稿件对象]
             * @return {[type]}       [description]
             */
            $scope.isLockEditForNewspaper = function (item) {
                hasEditRight(item).then(function () {
                    if (item.PAPERSTATUSNAME === '待修订') {
                        modalDialog.alertType('', '稿件在修订中,无法编辑', 'error', false, function () {
                            return;
                        });
                    } else {
                        editIsLock.isLock(item, 3).then(function (data) {
                            var editPath = $scope.status.newspaperEdit[item.DOCTYPEID];
                            var editParams = {
                                papermetadataid: item.METADATAID,
                                paperid: item.SITEID,
                                newspapertype: $scope.status.jrgedit
                            };
                            var editUrl = $state.href(editPath, editParams);
                            if (data.ISLOCK === 'false') {
                                $window.open(editUrl);
                            } else {
                                editIsLock.checkUnlockPermissions(item, data).then(function () {
                                    $window.open(editUrl);
                                });
                            }
                        });
                    }
                });
            };

            /**
             * [isSelectTime description] 是否进行了时间筛选
             * @return {Boolean} [description]
             */
            $scope.isSelectTime = function () {
                var res = (angular.isUndefined($scope.fromDate) || $scope.fromDate == '') && (angular.isUndefined($scope.untilDate) || $scope.untilDate == '');
                return res;
            };

            /**
             * [showMore description] 加载更多
             * @param  {[type]} item [description:稿件对象]
             * @return {[type]}       [description]
             */
            $scope.showMore = function (item) {
                var showNum = 0;
                if ($scope.status.OprTime != '') {
                    showNum = 9;
                } else {
                    showNum = item.SHOWDOCUMENTS.length + 10;
                }
                item.SHOWDOCUMENTS = item.DOCUMENTS.slice(0, showNum);
                $scope.status.OprTime = '';
            };

            /**
             * [loadSpecialData description] 加载特殊时间条件数据
             * @param  {[type]} oprTime [description] 时间条件（1天/3天）
             * @return {[type]}         [description]
             */
            $scope.loadSpecialData = function (oprTime) {
                $scope.status.page.PAGESIZE = 9;
                $scope.status.OprTime = oprTime;
                requestData().then(function () {
                    // newspaperDataInit(9);
                });
            };

            /**
             * [reloadData description] 纸媒数据为空时的加载更多
             * @return {[type]} [description]
             */
            $scope.reloadData = function () {
                $scope.status.page.PAGESIZE = 9;
                $scope.status.OprTime = '';
                requestData().then(function () {
                    // newspaperDataInit(9);
                });
            };

            /**
             * [newspaperPreview description] 报纸预览
             * @param  {[type]} item [description] 当前对象
             * @return {[type]}       [description]
             */
            $scope.newspaperPreview = function (item) {
                var paramsstateParams = {
                    paperid: item.SITEID,
                    bzmetadata: item.METADATAID,
                    newspapertype: $scope.status.sbgpreview,
                    paperstatusname: item.PAPERSTATUSNAME
                };
                var url = $state.href('newspaperNewsPreview', paramsstateParams);
                $window.open(url, '_black');
                storageListenerService.previewPageTurningStorage($scope.data.tableData, 'METADATAID,SITEID,DOCTYPEID', 'newspaperPreviewCache'); // news
            };
            // 流程版本与操作日志
            $scope.showVersionTime = function (item) {
                editingCenterService.getVersionTime(item, false);
            };

            /**
             * [isLockEdit description:编辑前请求解锁]
             * @param  {[type]} item [description:稿件对象]
             * @return {[type]}       [description]
             */
            $scope.isLockEdit = function (item) {
                if (item.PAPERSTATUSNAME == '待修订') {
                    modalDialog.alertType('', '稿件在修订中,无法编辑', 'error', false, function () {
                        return;
                    });
                } else {
                    editIsLock.isLock(item, 3).then(function (data) {
                        var editPath = $scope.status.newspaperEdit[item.DOCTYPEID];
                        var editParams = {
                            papermetadataid: item.METADATAID,
                            paperid: item.SITEID,
                            newspapertype: $scope.status.sbgedit
                        };
                        var editUrl = $state.href(editPath, editParams);
                        if (data.ISLOCK == 'false') {
                            $window.open(editUrl);
                        } else {
                            editIsLock.checkUnlockPermissions(item, data).then(function () {
                                $window.open(editUrl);
                            });
                        }
                    });
                }
            };
        }
    };
}]);
